import { TrueBase, css, html } from "../TrueBase/TrueBase";

/**
 * @customelement - true-slider-item
 * @description
 * Item inside a slider
 *
 * ### Properties
 *
 *
 */
export class TrueSliderItem extends TrueBase {
  static get properties() {
    return {
      slideWidth: {
        type: Number,
        reflect: false,
      },
      slideGap: {
        type: Number,
        reflect: false,
      },
      index: {
        type: Number,
        reflect: false,
      },
      active: {
        type: Boolean,
        reflect: false,
        attribute: false,
      },
    };
  }

  constructor() {
    super();
  }

  render() {
    return html`
      <div
        class="slide"
        style="width: ${this.slideWidth}px; margin: 0 ${this.slideGap}px;"
      >
        <slot></slot>
      </div>
    `;
  }

  static get styles() {
    return css`
      .slide {
        height: var(--slide-item-height, 100%);
        background: var(--slide-item-background, #cecece);
        display: var(--slide-item-display, flex);
        align-items: var(--slide-item-align-items, center);
        justify-content: var(--slide-item-justify-content, center);
        position: relative;
        outline: none;
        flex-shrink: 0;
      }
    `;
  }
}

window.customElements.get("true-slider-item") ||
  window.customElements.define("true-slider-item", TrueSliderItem);
